import {
  Button,
  Classes,
  Dialog,
  FormGroup,
  InputGroup,
  Switch,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { createViewModel } from "mobx-utils";
import * as React from "react";
import { IMva, newIMva } from "../../model";
import { MvaStorePA } from "../../stores/mvas/MvaStorePA";
import { MDBCol, MDBRow } from "mdbreact";
import { toast } from "react-toastify";
import MomentLocaleUtils from "react-day-picker/moment";
import { DateInput } from "@blueprintjs/datetime";
import * as moment from "moment";
import { getMomentFormatter } from "../../utils";
const InputMask = require("react-input-mask");

interface MvaPaDialogDuplicarProps {
  mva: IMva;
  onClose: () => void;
}

interface MvaPaDialogDuplicarState {
}

@observer
export class MvaPaDialogDuplicar
  extends React.Component<MvaPaDialogDuplicarProps, MvaPaDialogDuplicarState> {
  obs = observable({
    mva: newIMva() as IMva
  })

  async componentDidMount() {
    this.obs.mva = createViewModel(observable(this.props.mva));
  }

  handleSaveDuplica = async (mva) => {
    if (this.obs.mva.produto_cest == "") {
      toast.warning('Preencha um CEST.', {});
      return
    }
    if (this.obs.mva.item == "") {
      toast.warning('Preencha o ITEM.', {});
      return
    }
    if (this.obs.mva.produto_ncm == "") {
      toast.warning('Preencha o NCM', {});
      return
    }

    if (this.obs.mva.entrada) {

      if (this.obs.mva.margem_industrial_4 == "") {
        toast.warning('Preencha a Alíquota Industrial 4%.', {});
        return;
      }
      if (this.obs.mva.margem_industrial_7 == "") {
        toast.warning('Preencha a Alíquota Industrial 7%.', {});
        return;
      }
      if (this.obs.mva.margem_industrial_12 == "") {
        toast.warning('Preencha a Alíquota Industrial 12%.', {});
        return;
      }
      if (this.obs.mva.margem_distribuidor_4 == "") {
        toast.warning('Preencha a Alíquota Distribuidor 4%', {});
        return;
      }
      if (this.obs.mva.margem_distribuidor_7 == "") {
        toast.warning('Preencha a Alíquota Distribuidor 7%', {});
        return;
      }
      if (this.obs.mva.margem_distribuidor_12 == "") {
        toast.warning('Preencha a Alíquota Distribuidor 12%', {});
        return;
      }

    } else {

      if (this.obs.mva.margem_industrial_19 == "") {
        toast.warning('Preencha a Alíquota Industrial 19%.', {});
        return;
      }
      if (this.obs.mva.margem_distribuidor_19 == "") {
        toast.warning('Preencha a Alíquota Distribuidor 19%', {});
        return;
      }
    }

    var valido_de = mva.valido_de ? moment(mva.valido_de).format("YYYY-MM-DD") : null;
    var valido_ate = mva.valido_ate ? moment(mva.valido_ate).format("YYYY-MM-DD") : null;

    if (valido_de != null && valido_ate != null) {
      if (valido_de > valido_ate) {
        toast.warning('Campo (Valido de) não pode ser maior que (Valido até)', {});
        return;
      }
    }

    let params = {
      item: mva.item,
      margem_distribuidor_12: mva.margem_distribuidor_12?.replace("%", ""),
      margem_distribuidor_19: mva.margem_distribuidor_19?.replace("%", ""),
      margem_distribuidor_4: mva.margem_distribuidor_4?.replace("%", ""),
      margem_distribuidor_7: mva.margem_distribuidor_7?.replace("%", ""),
      margem_industrial_12: mva.margem_industrial_12?.replace("%", ""),
      margem_industrial_19: mva.margem_industrial_19?.replace("%", ""),
      margem_industrial_4: mva.margem_industrial_4?.replace("%", ""),
      margem_industrial_7: mva.margem_industrial_7?.replace("%", ""),
      produto_cest: mva.produto_cest,
      produto_desc: mva.produto_desc,
      produto_ncm: mva.produto_ncm,
      valido_de: valido_de,
      valido_ate: valido_ate,
      entrada: mva.entrada,
    }

    let res = await MvaStorePA.doSaveDuplicaMva(params);

    if (res) {
      this.props.onClose()
    }

  };

  render() {
    if (!this.obs.mva) {
      return null;
    }
    let dayPickerProps = {
      localeUtils: MomentLocaleUtils,
      locale: "pt-br",
    };

    return (
      <Dialog
        isOpen={true}
        onClose={this.props.onClose}
        style={{ width: 600, height: 400 }}
      >
        <div className={Classes.DIALOG_HEADER}>
          <div style={{ display: "flex", width: "100%" }}>
            <h2 className="title-no-bottom">Duplicar MVA</h2>
            <Switch
              checked={this.obs.mva.entrada}
              onChange={(e: any) => this.obs.mva.entrada = e.target.checked}
              innerLabelChecked="Entrada" innerLabel="Saída"
              style={{ marginTop: 12, marginLeft: "auto", fontSize: 12, fontWeight: 600 }}
            />
          </div>
        </div>

        <div className={Classes.DIALOG_BODY}>
          <div style={{ marginTop: -25 }}>
            <FormGroup
              label="Item"
              labelFor="item"
            >
              <InputGroup
                id="item"
                value={this.obs.mva.item}
                onChange={(e) => this.obs.mva.item = e.target.value}
              />
            </FormGroup>

            <FormGroup
              label="CEST"
              labelFor="cest"
            >
              <InputMask
                mask="99.999.99"
                className="form-control"
                onChange={(e) => this.obs.mva.produto_cest = e.target.value}
                value={this.obs.mva.produto_cest}
              />
            </FormGroup>

            <FormGroup
              label="NCM (separador por vírgula e com ponto)"
              labelFor="ncm"
            >
              <InputGroup
                id="ncm"
                value={this.obs.mva.produto_ncm.replace("\n", ",")}
                onChange={(e) => this.obs.mva.produto_ncm = e.target.value}
                placeholder="Exemplo: 3003,3006.60.00"
              />
            </FormGroup>

            <FormGroup
              label="Descrição"
              labelFor="descricao"
            >
              <InputGroup
                id="descricao"
                value={this.obs.mva.produto_desc}
                onChange={(e) => this.obs.mva.produto_desc = e.target.value}
              />
            </FormGroup>

            <MDBRow xl="12" lg="12" md="12" sm="12" xs="12">
              <MDBCol>
                <FormGroup label="Valido de">
                  <DateInput
                    {...getMomentFormatter("DD/MM/YYYY")}
                    locale="pt-br"
                    dayPickerProps={dayPickerProps}
                    value={this.obs.mva.valido_de ? this.obs.mva.valido_de : null}
                    onChange={(e) => this.obs.mva.valido_de = e}
                    placeholder="DD/MM/AAAA"
                    canClearSelection
                  />
                </FormGroup>
              </MDBCol>

              <MDBCol>
                <FormGroup label="Valido até">
                  <DateInput
                    {...getMomentFormatter("DD/MM/YYYY")}
                    locale="pt-br"
                    dayPickerProps={dayPickerProps}
                    value={this.obs.mva.valido_ate ? this.obs.mva.valido_ate : null}
                    onChange={(e) => this.obs.mva.valido_ate = e}
                    placeholder="DD/MM/AAAA"
                    canClearSelection
                  />
                </FormGroup>
              </MDBCol>
            </MDBRow>
            {this.obs.mva.entrada ?

              <MDBRow xl="12" lg="12" md="12" sm="12" xs="12">
                <MDBCol>
                  <FormGroup
                    label="Alíquota Industrial 4%"
                    labelFor="margem_industrial_4"
                  >
                    <InputGroup
                      id="margem_industrial_4"
                      value={this.obs.mva.margem_industrial_4.replace("%", "")}
                      onChange={(e) =>
                        this.obs.mva.margem_industrial_4 = e.target.value}
                      placeholder="Exemplo: 54,8950"
                    />
                  </FormGroup>

                  <FormGroup
                    label="Alíquota Industrial 7% "
                    labelFor="margem_industrial_7"
                  >
                    <InputGroup
                      id="margem_industrial_7"
                      value={this.obs.mva.margem_industrial_7.replace("%", "")}
                      onChange={(e) =>
                        this.obs.mva.margem_industrial_7 = e.target.value}
                      placeholder="Exemplo: 54,8950"
                    />
                  </FormGroup>

                  <FormGroup
                    label="Alíquota Industrial 12% "
                    labelFor="margem_industrial_12"
                  >
                    <InputGroup
                      id="margem_industrial_12"
                      value={this.obs.mva.margem_industrial_12.replace("%", "")}
                      onChange={(e) =>
                        this.obs.mva.margem_industrial_12 = e.target.value}
                      placeholder="Exemplo: 54,8950"
                    />
                  </FormGroup>
                </MDBCol>
                <MDBCol>
                  <FormGroup
                    label="Alíquota Distribuidor 4%"
                    labelFor="margem_distribuidor_4"
                  >
                    <InputGroup
                      id="margem_distribuidor_4"
                      value={this.obs.mva.margem_distribuidor_4.replace("%", "")}
                      onChange={(e) =>
                        this.obs.mva.margem_distribuidor_4 = e.target.value}
                      placeholder="Exemplo: 54,8950"
                    />
                  </FormGroup>
                  <FormGroup
                    label="Alíquota Distribuidor 7% "
                    labelFor="margem_distribuidor_7"
                  >
                    <InputGroup
                      id="margem_distribuidor_7"
                      value={this.obs.mva.margem_distribuidor_7.replace("%", "")}
                      onChange={(e) =>
                        this.obs.mva.margem_distribuidor_7 = e.target.value}
                      placeholder="Exemplo: 54,8950"
                    />
                  </FormGroup>

                  <FormGroup
                    label="Alíquota Distribuidor 12%"
                    labelFor="margem_distribuidor_12"
                  >
                    <InputGroup
                      id="margem_distribuidor_12"
                      value={this.obs.mva.margem_distribuidor_12.replace("%", "")}
                      onChange={(e) =>
                        this.obs.mva.margem_distribuidor_12 = e.target.value}
                      placeholder="Exemplo: 54,8950"
                    />
                  </FormGroup>
                </MDBCol>
              </MDBRow>
              :

              <MDBRow xl="12" lg="12" md="12" sm="12" xs="12">
                <MDBCol>
                  <FormGroup
                    label="Alíquota Industrial 19% "
                    labelFor="margem_industrial_19"
                  >
                    <InputGroup
                      id="margem_industrial_19"
                      value={this.obs.mva.margem_industrial_19.replace("%", "")}
                      onChange={(e) =>
                        this.obs.mva.margem_industrial_19 = e.target.value}
                      placeholder="Exemplo: 54,8950"
                    />
                  </FormGroup>
                </MDBCol>
                <MDBCol>
                  <FormGroup
                    label="Alíquota Distribuidor 19%"
                    labelFor="margem_distribuidor_19"
                  >
                    <InputGroup
                      id="margem_distribuidor_19"
                      value={this.obs.mva.margem_distribuidor_19.replace("%", "")}
                      onChange={(e) =>
                        this.obs.mva.margem_distribuidor_19 = e.target.value}
                      placeholder="Exemplo: 54,8950"
                    />
                  </FormGroup>
                </MDBCol>
              </MDBRow>
            }
          </div>
        </div>

        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={this.props.onClose} />
            <Button
              text="Criar uma Cópia"
              intent="primary"
              onClick={() => this.handleSaveDuplica(this.obs.mva)}
            />
          </div>
        </div>
      </Dialog>
    );
  }
}
